// extracted by mini-css-extract-plugin
module.exports = {"matrix-table--pad3":"l_x ml-3","matrix-table--pad4":"l_y ml-5","matrix-table__title":"l_z","matrix-table__true":"l_B","matrix-table__false":"l_C"};